import i18next            from "i18next";
import {initReactI18next} from "react-i18next";
import Backend            from "i18next-http-backend";
import {LocaleNamespace}  from "./helpers";

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend      : {
      loadPath: "/assets/locales/{{lng}}/{{ns}}.json",
    },
    debug        : process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test",
    defaultNS    : LocaleNamespace.Common,
    fallbackLng  : "fr",
    interpolation: {
      escapeValue: false,
    }, // @ts-ignore
    lng          : "fr" | navigator.language || navigator.userLanguage, // TODO
    load         : "languageOnly",
    ns           : Object.values(LocaleNamespace),
    react        : {
      useSuspense: false,
      wait       : true,
    },
  });

export default i18next; // imported in root (src/index.js|ts)
